import React from 'react'
import PageHeader from '../../components/PageHeader'
import OrdersTable from './OrdersTable'

const Orders = () => {
  return (
    <div className="dashboard-container">
      <PageHeader title="Outbound: Orders" dateLabel="Order Received Date"/>
      <OrdersTable />
    </div>
  )
}

export default Orders